export const studioKeys = {
  all: ['studios'] as const,
  lists: () => [...studioKeys.all, 'list'] as const,
};
